import React from 'react';

const CartIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg width="18" height="16" viewBox="0 0 18 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M13.7262 8C12.8807 8 12.0541 8.2346 11.3511 8.67412C10.6481 9.11365 10.1002 9.73836 9.77659 10.4693C9.45302 11.2002 9.36836 12.0044 9.53332 12.7804C9.69827 13.5563 10.1054 14.269 10.7033 14.8284C11.3012 15.3878 12.0629 15.7688 12.8922 15.9231C13.7214 16.0775 14.581 15.9983 15.3621 15.6955C16.1433 15.3928 16.811 14.8801 17.2807 14.2223C17.7504 13.5645 18.0012 12.7911 18.0012 12C17.9999 10.9395 17.5491 9.92275 16.7477 9.17286C15.9462 8.42297 14.8596 8.00116 13.7262 8ZM15.2451 13.158L13.5351 12.358C13.464 12.3248 13.4043 12.2737 13.3625 12.2104C13.3207 12.1472 13.2986 12.0743 13.2987 12V10C13.2987 9.89391 13.3437 9.79217 13.4239 9.71716C13.5041 9.64214 13.6128 9.6 13.7262 9.6C13.8396 9.6 13.9483 9.64214 14.0285 9.71716C14.1086 9.79217 14.1537 9.89391 14.1537 10V11.7528L15.6273 12.442C15.7287 12.4894 15.8059 12.5726 15.8418 12.6733C15.8778 12.774 15.8695 12.8839 15.8188 12.9788C15.7681 13.0737 15.6792 13.146 15.5716 13.1796C15.464 13.2132 15.3466 13.2054 15.2451 13.158Z"
        fill="#F71D65"
      />
      <path
        d="M8.7149 11.8697C8.71472 12.6048 8.92389 13.3284 9.32364 13.9758C9.7234 14.6232 10.3013 15.174 11.0055 15.5789H2.1285C1.82659 15.5792 1.52807 15.5235 1.2528 15.4154C0.977539 15.3074 0.731842 15.1495 0.532063 14.9523C0.332283 14.7551 0.183003 14.5231 0.0941539 14.2717C0.00530503 14.0203 -0.0210745 13.7553 0.0167707 13.4943L1.29403 4.59208C1.35836 4.14361 1.60844 3.73103 1.99729 3.43187C2.38614 3.13271 2.887 2.96755 3.40576 2.96742H4.45737V5.19298C4.45737 5.29136 4.50223 5.38571 4.58207 5.45527C4.66192 5.52483 4.77021 5.56391 4.88313 5.56391C4.99604 5.56391 5.10433 5.52483 5.18418 5.45527C5.26402 5.38571 5.30888 5.29136 5.30888 5.19298V2.96742H10.4179V5.19298C10.4179 5.29136 10.4628 5.38571 10.5426 5.45527C10.6225 5.52483 10.7307 5.56391 10.8437 5.56391C10.9566 5.56391 11.0649 5.52483 11.1447 5.45527C11.2246 5.38571 11.2694 5.29136 11.2694 5.19298V2.96742H12.321C12.8398 2.96755 13.3406 3.13271 13.7295 3.43187C14.1184 3.73103 14.3684 4.14361 14.4328 4.59208L14.85 7.50757C14.1075 7.37632 13.3408 7.39035 12.6053 7.54863C11.8698 7.70691 11.1837 8.0055 10.5968 8.42284C10.0098 8.84019 9.5365 9.36587 9.21106 9.96194C8.88563 10.558 8.71616 11.2096 8.7149 11.8697ZM11.2694 2.96742H10.4179C10.4179 2.37716 10.1488 1.81108 9.66971 1.39371C9.19065 0.976333 8.54089 0.741855 7.86339 0.741855C7.18589 0.741855 6.53614 0.976333 6.05708 1.39371C5.57801 1.81108 5.30888 2.37716 5.30888 2.96742H4.45737C4.45737 2.18041 4.81622 1.42564 5.45497 0.869137C6.09373 0.312638 6.96006 0 7.86339 0C8.76673 0 9.63306 0.312638 10.2718 0.869137C10.9106 1.42564 11.2694 2.18041 11.2694 2.96742Z"
        fill="#F71D65"
      />
      <rect x="3.64355" y="14.0078" width="4.29677" height="0.728745" rx="0.364372" fill="url(#paint0_linear_90550_155366)" />
      <rect x="1.34961" y="12.2754" width="7.2" height="0.728745" rx="0.364372" fill="url(#paint1_linear_90550_155366)" />
      <rect x="4.01855" y="10.5264" width="4.23871" height="0.728745" rx="0.364372" fill="url(#paint2_linear_90550_155366)" />
      <path
        d="M8.5791 8.8418C8.81159 8.8418 8.99992 9.03023 9 9.2627C9 9.49524 8.81164 9.68359 8.5791 9.68359H5.82129C5.58882 9.68351 5.40039 9.49518 5.40039 9.2627C5.40047 9.03028 5.58887 8.84188 5.82129 8.8418H8.5791Z"
        fill="white"
      />
      <defs>
        <linearGradient
          id="paint0_linear_90550_155366"
          x1="8.16556"
          y1="14.368"
          x2="3.65113"
          y2="14.2831"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C52664" />
          <stop offset="0.35373" stopColor="#FF7478" />
          <stop offset="0.95873" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint1_linear_90550_155366"
          x1="8.92703"
          y1="12.6356"
          x2="1.36713"
          y2="12.3975"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C52664" />
          <stop offset="0.35373" stopColor="#FF7478" />
          <stop offset="0.95873" stopColor="white" />
        </linearGradient>
        <linearGradient
          id="paint2_linear_90550_155366"
          x1="8.47945"
          y1="10.8865"
          x2="4.02598"
          y2="10.804"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#C52664" />
          <stop offset="0.35373" stopColor="#FF7478" />
          <stop offset="0.95873" stopColor="white" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default CartIcon;
